"use client";

import React from "react";
import dynamic from "next/dynamic";
import OurWebsites from "@/app/components/OurWebsites/OurWebsites";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

// Dynamically import LogoSlider with SSR disabled
const LogoSlider = dynamic(
  () => import("@/app/components/LogoSlider/LogoSlider"),
  { ssr: false }
);
const GraphicPresentations = dynamic(
  () => import("@/app/components/GraphicPresentations/GraphicPresentations"),
  { ssr: false }
);
const FeaturedWebsitesPortfolio = dynamic(
  () => import("@/app/components/FeaturedProjects/FeaturedProjectsOnPortfolio"),
  { ssr: false }
);

export default function PortfolioPage() {
  return (
    <section className="portfolio-section flex flex-col items-center gap-[100px] md:gap-[150px] my-[35px]">
      <FirstBlockAbout
        title="See projects done by Enjoyable Design INC."
        highlightWords={["Enjoyable", "Design", "INC."]}
        tags={["Logo Design", "Web Development", "Graphic Presentations"]}
        media={{
          type: "image",
          src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FFirst%20Block%20Images%2FOurWorksFirstImage.webp?alt=media&token=a36a9a2d-2eb6-4405-8ea9-e6942928bbe9",
        }}
      />
      <LogoSlider
        logos={[
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2FAverlexx.webp?alt=media&token=f92cdebb-8642-460c-a836-644fd0d4d07e",
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2FCasaMountHouse.webp?alt=media&token=901dc1e3-cf9e-4378-9e7e-540c65f4917d",
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2Fblondhaus.webp?alt=media&token=8ef76800-a2f7-48cb-a9ef-94b6eb169e93",
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2Flipiec.webp?alt=media&token=4c54c8a5-300e-4bd8-bc27-e3fc5e9716f9",
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2Frenoexpress.webp?alt=media&token=a99b5b85-5baf-487d-b7ab-cf20fedb608b",
          "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FBlackWhite%20Logos%2FCleofaucets.webp?alt=media&token=74621e08-0b94-46e7-9171-f039e635a725",
        ]}
        id="logo-design"
      />
      <OurWebsites
        blocks={[
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FMMADigital%2FMMALogo.svg?alt=media&token=c216bc40-72c0-4ecf-95f8-afda56d2bd4b",
            title: "MMA Digital Group",
            link: "/about/portfolio/MMADigital",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2F100Bond%2F100bondLogo.webp?alt=media&token=9cd46133-b1ac-4bf5-a92e-4584b18f427f",
            title: "100 Bond",
            link: "/about/portfolio/100bond",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Flogo-v2.svg?alt=media&token=e7d3e05e-dc58-409e-9e47-f5e31882c891",
            title: "George Street Lofts",
            link: "/about/portfolio/georgestreetlofts",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2FPlumbingMarketLogo.webp?alt=media&token=ed65123b-0cf8-4397-a66d-c9f2853e448c",
            title: "Plumbing Market",
            link: "/about/portfolio/plumbingmarket",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2Faverlexx%20logo.webp?alt=media&token=e4b4aaf2-a1b5-4b1a-883c-f7bac10a629a",
            title: "Averlexx",
            link: "/about/portfolio/averlexx",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2FCleo%20Logo.webp?alt=media&token=101c6509-ac15-4b27-9504-fc46c3f3983e",
            title: "Cleo Faucets",
            link: "/about/portfolio/cleofaucets",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2Ftjyadavlogo.webp?alt=media&token=4fd48bd5-6ede-49f4-9c0e-97d4b85ec91e",
            title: "TJ Financing",
            link: "/about/portfolio/tjyadav",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2FCasamount%20logo.webp?alt=media&token=e2d7a255-f0a0-4c58-989d-89e88a36ec11",
            title: "Casamount House",
            link: "/about/portfolio/casamaunt",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2Fblondhaus%20logo.webp?alt=media&token=5aa9ac0f-3606-4f89-93a7-265daff9ad54",
            title: "Blondhaus",
            link: "/about/portfolio/blondhaus",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2Fprismpmlogo.webp?alt=media&token=4d715416-2e9f-4d7f-90ba-2e0a9e61f510",
            title: "PrismPm",
            link: "/about/portfolio/prismpm",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2Flipieclogo.webp?alt=media&token=dff26a2c-06a8-4ea9-8b07-9738301f07cb",
            title: "Lipiec Meats",
            link: "/about/portfolio/lipiecmeats",
          },
          {
            image:
              "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FOurWorksPortfolio%2FrossahutLogo.svg?alt=media&token=57abb4aa-752f-426b-a5de-eb4f8920bac7",
            title: "Rossahut",
            link: "/about/portfolio/rossahut",
          },

          // {
          //   image:
          //     "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGolzar%2FgolzarLogo.webp?alt=media&token=363fb6d0-c633-4f2f-af19-8d01904ee07d",
          //   title: "Golzar",
          //   link: "/about/portfolio/golzar",
          // },
        ]}
      />
      <GraphicPresentations />
    </section>
  );
}
